import { render, staticRenderFns } from "./DepositView.vue?vue&type=template&id=379432b8&scoped=true"
import script from "./DepositView.vue?vue&type=script&lang=js"
export * from "./DepositView.vue?vue&type=script&lang=js"
import style0 from "./DepositView.vue?vue&type=style&index=0&id=379432b8&prod&lang=scss&scoped=true"
import style1 from "./DepositView.vue?vue&type=style&index=1&id=379432b8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "379432b8",
  null
  
)

export default component.exports